import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

export interface CheckboxBaseProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: React.ReactNode
  name: string
}

export const CheckboxBase = React.forwardRef<
  HTMLLabelElement,
  CheckboxBaseProps
>(function CheckboxBase(
  { className, checked, disabled, onChange, style, label, name },
  ref,
) {
  return (
    <label
      ref={ref}
      className={clsx(className, s.checkbox)}
      htmlFor={`checkbox_${name}`}
      style={style}
    >
      <input
        type='checkbox'
        id={`checkbox_${name}`}
        name={`checkbox_${name}`}
        checked={checked}
        readOnly={true}
        disabled={disabled}
        onChange={onChange}
        data-gtm='private-checkbox'
        className='cursor-pointer'
      />
      {label}
    </label>
  )
})
